import Target from 'dashboard/components/GraphCanvasV2/target/target';
import { CanvasSelectable } from 'dashboard/models/graph';

export interface CanvasEdge {
  source: CanvasSelectable;
  target: CanvasSelectable;
}

export default class CanvasEdgeTarget extends Target<CanvasEdge> {
  type = 'edge';
}
